import { nanoid } from '@reduxjs/toolkit'
import { getPathAdAccountId } from 'utils'

export const filterStorageKey = 'dashboardFilterHistory'

const getStorageItem = () =>
  JSON.parse(localStorage.getItem(filterStorageKey)) || {}

export const getFilterHistory = () => {
  const storageItem = getStorageItem()
  const adAccountId = getPathAdAccountId()
  return storageItem[adAccountId] || []
}

export const persistFilterHistory = (filters = []) => {
  if (filters.length > 0) {
    const adAccountId = getPathAdAccountId()
    const filterHistory = getFilterHistory()
    filterHistory.unshift({ id: nanoid(), filters })
    const storageItem = getStorageItem()
    storageItem[adAccountId] = filterHistory.slice(0, 20)
    localStorage.setItem(filterStorageKey, JSON.stringify(storageItem))
  }
}

export const clearFilterHistory = () => {
  const adAccountId = getPathAdAccountId()
  const storageItem = getStorageItem()
  storageItem[adAccountId] = []
  localStorage.setItem(filterStorageKey, JSON.stringify(storageItem))
}
